export default __webpack_public_path__ + "static/media/empty-box.6d9b4fa1.svg";